import { VideoWrapper } from './wrappers/VideoWrapper';
import { shouldUseAgoraWrapper, shouldUseIvsWrapper } from './helpers';
/**
 * Resolve and import the appropriate video wrapper class based on the video type.
 * @param video
 * @returns
 */
export const resolveWrapperClass = async (video) => {
    if (shouldUseAgoraWrapper(video)) {
        const { AgoraWrapper } = await import('./wrappers/AgoraWrapper');
        return AgoraWrapper;
    }
    else if (shouldUseIvsWrapper(video)) {
        const { isIVSSupported, IVSWrapper } = await import('./wrappers/IVSWrapper');
        if (isIVSSupported()) {
            return IVSWrapper;
        }
    }
    return VideoWrapper;
};
